export default `#ifdef GL_ES
precision highp float;
precision highp int;
#endif

#include <common>
#include <clipping_planes_pars_vertex>

uniform sampler2D texture1;
uniform bool displayClasses;

uniform float pointSize;

uniform float pointSizeScale;

uniform float screenHeight;

uniform float maximumAttenuation;

uniform float pointScale; 
uniform bool attenuation;  

#ifdef NO_NORMALS

uniform vec3 lightDirection;
#endif

attribute float classification;

#ifdef ADAPTIVE_OCTREE

uniform sampler2D visibleNodes;

uniform int nodeIndex;

uniform vec3 cubeCenter;
uniform float cubeHalfSize;

int readByte(float channel) {
  return int(round(channel * 255.0));
}

float adaptiveSizeScale() {
  if (nodeIndex < 0) {
    return 1.0;
  }

  int index = nodeIndex;
  vec3 center = cubeCenter;
  float halfSize = cubeHalfSize;
  float scale = 1.0;
  
  for (int level = 0; level < 20; level++) {
    vec4 node = texelFetch(visibleNodes, ivec2(index % 256, index / 256), 0);
    int mask = readByte(node.r);
    int octant = (position.x >= center.x ? 1 : 0) + (position.y >= center.y ? 2 : 0) +
      (position.z >= center.z ? 4 : 0);
    if (((mask >> octant) & 1) == 0) {
      break;
    }

    
    int before = 0;
    for (int bit = 0; bit < octant; bit++) {
      before += (mask >> bit) & 1;
    }
    index = readByte(node.g) + readByte(node.b) * 256 + before;

    halfSize *= 0.5;
    center += (vec3(float(octant & 1), float((octant >> 1) & 1), float((octant >> 2) & 1)) * 2.0 - 1.0) * halfSize;
    scale *= 0.5;
  }
  return scale;
}
#endif

varying float vClassification;
varying vec4 vColor;
varying vec3 vNormal;

float resolveCullOffset(float classOpacity) {
  return displayClasses ? 999999.0 * (1.0 - classOpacity) : 0.0;
}

void main() {
  vClassification = classification;
  vColor = vec4(color.rgb, 1.0);
#ifdef NO_NORMALS
  vNormal = lightDirection;
#else
  vNormal = vec3(normal);
#endif

  vec4 texture = texture2D(texture1, vec2((vClassification + 0.5) / 67.0, 0.0));

  vec3 transformed = position;
  transformed.x += resolveCullOffset(texture.a);

  vec4 mvPosition = modelViewMatrix * vec4(transformed, 1.0);
  gl_Position = projectionMatrix * mvPosition;

  
  
  
  
  
  
  
  
  
  
  
  
  
  if (attenuation) {
    float focalLength = projectionMatrix[1][1]; 
    float worldSize = pointSize;
#ifdef ADAPTIVE_OCTREE
    worldSize *= adaptiveSizeScale();
#endif
    float sizePixels = worldSize * focalLength * screenHeight * 0.5;
    if (!isOrthographic) {
      sizePixels /= -mvPosition.z;
    }
    gl_PointSize = clamp(sizePixels / pointSizeScale * pointScale, 1.0, maximumAttenuation);
  } else {
    gl_PointSize = clamp(pointScale, 1.0, maximumAttenuation);
  }

  #include <worldpos_vertex>
  #include <clipping_planes_vertex>
}`